import React, { useEffect, useState } from "react";
import { axios, setToken } from "../api/Api";
import { Link, useHistory } from "react-router-dom";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoggedIn, setErrors } from "../utils/Actions";
import Navbar from "./Navbar";
import LoginApi from "../api/Login";

export default function Header() {
  const [{ isLoggedIn, sysCfg }, dispatch] = useGlobalValue();
  const [logo, setLogo] = useState("/images/mow_logo.jpg");
  let history = useHistory();

  const signOut = () => {
    LoginApi.logout().then(response => {
      setIsLoggedIn(false, dispatch);
      localStorage.removeItem("token");
      axios.defaults.headers.common["Authorization"] = null;
      history.push("/login");
    }).catch(apiErrors => {
        setErrors(apiErrors, dispatch);
    })    
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token && !isLoggedIn) {
      setIsLoggedIn(true, dispatch);
      setToken(token);
    }

    if (sysCfg !== undefined && sysCfg.hasOwnProperty("mealordering_logo") && sysCfg.mealordering_logo !== "") {
      // For testing, full logo url should be: https://icrm-data.s3-ap-southeast-2.amazonaws.com/ + module + /files/ + sysCfg.mealordering_logo
      let s3Url = "https://icrm-data.s3-ap-southeast-2.amazonaws.com/" + window.location.hostname.split(".meal-ordering.com.au")[0] + "/files/";
      setLogo(s3Url + sysCfg.mealordering_logo);
    }
  }, [sysCfg, dispatch, isLoggedIn]);

  return (
    <header style={{ background: "white" }}>
      <div className="container">
        <div className="row">
          <div className="col-3 text-left" style={{ padding: 15 }}>
            <Link to="/">
              <img src={logo} style={{ maxHeight: 100 }} alt="Logo" />
            </Link>
          </div>
          <div className="col-9 text-left" style={{ paddingTop: 30 }}>
            <h1>Meals on Wheels</h1>
          </div>
        </div>
      </div>
      <Navbar signOut={signOut} isLoggedIn={isLoggedIn} />
    </header>
  );
}
